import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'
import styled from 'styled-components'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { getStatsApiQuery } from '../utils/query'

/**
 * 平板违规统计卡片：Content 行 CommonCard 样式（与电子违规等卡片同风格）
 */
export const PadViolationCard: FC<{ style?: React.CSSProperties }> = ({
  style,
}) => {
  const { semesterInfo, timeRange, role } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()
  const { week_number, month_number } = getStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentTabletViolationStats',
    params: {
      query: {
        semester_id: semesterInfo.semester_id,
        week_number,
        month_number,
        advisor_usin: reflection?.usin || '',
        advisor_role: role,
      },
    },
    disable: !reflection?.usin,
  })

  const {
    total_violation_student_count = 0,
    app_violation_student_count = 0,
    device_violation_student_count = 0,
    offline_violation_student_count = 0,
    avg_usage_over_student_count = 0,
  } = res?.data?.[0] || {}

  return (
    <IndexBoardCard
      style={style}
      title={$t('平板异常统计')}
      count={total_violation_student_count}
      items={[
        { label: $t('APP使用'), value: app_violation_student_count },
        { label: $t('设备使用'), value: device_violation_student_count },
        { label: $t('离线次数'), value: offline_violation_student_count },
        {
          label: $t('用时预警'),
          value: Number(avg_usage_over_student_count),
        },
      ]}
      flex={2}
      type={StatsDetailsTabEnum.StudentPadUsageRecord}
      loading={loading}
      tips={
        <TipsList>
          <li>
            {$t(
              '统计 APP使用异常、设备使用异常、离线异常 任一维度超过5次的人数'
            )}
          </li>
          <li>{$t('用时预警：统计日均时长超过3小时的人数')}</li>
        </TipsList>
      }
      itemIconMsg={{
        name: 'DeviceTabletSpeaker',
        color: '#0A6CFF',
        backgroundColor: '#E8F5FF',
      }}
    />
  )
}

const TipsList = styled.ul`
  margin: 0;
  padding-left: 16px;
  font-size: 12px;
  line-height: 1.6;

  li {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`
